import React from 'react';

const VideoPlayer = () => {
    return (
        <div>
            <video autoPlay width="100%" height="100%" controls>
                <source
                    src="https://daviestorage.blob.core.windows.net/devcontainer/uploads/DAVIE_30.mp4"
                    type="video/mp4"
                />
            </video>
        </div>
    );
};

export default VideoPlayer;
